import Repository from "./repository"

export default {
    /**
     * S20401_ご契約内容表示
     *
     * @param {object} params リクエストパラメータ
     */
    get(params) {
        return Repository.get('/api/s204-chat-contract-details/view', { params: params })
    }
}